module.exports = __webpack_public_path__ + "static/media/fixed-icon-done.5bb40a0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fixed-icon-done.svg
// module id = 3227
// module chunks = 0